import axios from 'axios';
import React , {useEffect, useState} from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Line } from 'react-chartjs-2';
import { flexbox } from '@mui/system';
import { chartDays } from '../data';



const CoinInfo = ({coin}) => {
    const [historicData ,setHistoricData] = useState();
    const [days, setDays]= useState(1);

    const useStyles = makeStyles((theme) => ({
        container: {
          width: "60%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 25,
          padding: 40,
        //   [theme.breakpoints.down("md")]: {
        //     width: "100%",
        //     marginTop: 0,
        //     padding: 20,
        //     paddingTop: 0,
        //   },
        },
      }));

      const classes = useStyles()

    const darkTheme = createTheme({
        palette: {
          primary: {
            main: "#fff",
          },
          background: {
            // default: deepOrange[900],
            paper: "rgba(255, 255, 255, 0.16)",
          },
          text: {
            primary: "rgba(255, 255, 255, 0.7) ",
            secondary: "rgba(255, 255, 255, 0.7) ",
          },
          type: "dark",
        },
      });

    const fetchHistoricData = async() => {
        const {data} = await axios.get(`https://api.coingecko.com/api/v3/coins/${coin.id}/market_chart?vs_currency=usd&days=${days}`)
        

        console.log(data.prices)
        setHistoricData(data.prices)
    }

    useEffect(() => {
        fetchHistoricData()
    }, [days])
    return (
        <ThemeProvider theme={darkTheme}>
         <div className={classes.container}>
        {!historicData ? (
          <CircularProgress
            style={{ color: "gold" }}
            size={250}
            thickness={1}
          />
        ) : (
          <>
            <Line
              data={{
                labels: historicData.map((coin) => {
                  let date = new Date(coin[0]);
                  let time =
                    date.getHours() > 12
                      ? `${date.getHours() - 12}:${date.getMinutes()} PM`
                      : `${date.getHours()}:${date.getMinutes()} AM`;
                  return days === 1 ? time : date.toLocaleDateString();
                }),

                datasets: [
                  {
                    data: historicData.map((coin) => coin[1]),
                    label: `Price ( Past ${days} Days ) in usd`,
                    borderColor: "#EEBC1D",
                  },
                ],
              }}
              options={{
                elements: {
                  point: {
                    radius: 1,
                  },
                },
              }}
            />
            <div
              style={{
                display: "flex",
                marginTop: 20,
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              {chartDays.map((day) => (
                  <Button key={day.value} onClick={() => setDays(day.value)} variant="outlined">{day.label}</Button>

                // <SelectButton
                //   key={day.value}
                //   onClick={() => setDays(day.value)}
                //   selected={day.value === days}
                // >
                //   {day.label}
                // </SelectButton>
              ))}
            </div>
          </>
        )}
    </div>
 </ThemeProvider>
    )
}

export default CoinInfo
